import {requestHeader, request} from './api';

export const get = () => {
    return requestHeader(`/admin/category`, {
        method: 'GET',
    });
};

export const create = (category) => {
    return request(`/admin/category`, {
        method: 'POST',
        body: JSON.stringify(category),
    });
};

export const update = (category) => {
    return request(`/admin/category`, {
        method: 'PUT',
        body: JSON.stringify(category),
    });
};

export const updateCategoryStatus = (id, active) => {
    return request(`/admin/category/update-category-status?${new URLSearchParams({id, active}).toString()}`, {
        method: 'PUT',
    });
};

export const updateSubcategoryStatus = (id, active) => {
    return request(`/admin/category/update-subcategory-status?${new URLSearchParams({id, active}).toString()}`, {
        method: 'PUT',
    });
};

export const getById = (id) => {
    return request(`/admin/category/${id}`, {
        method: 'GET',
    });
};

export const remove = (id) => {
    return request(`/admin/category/${id}`, {
        method: 'DELETE',
    });
};
 
export default {get}